export enum EInternalNoteType {
  PERSONAL = 'PERSONAL',
  PROGRESS = 'PROGRESS',
  INCIDENT = 'INCIDENT',
  NON_ATTENDANCE = 'NON_ATTENDANCE'
}
